/**
 * Extracts usage data from a billing plan exception payload if it exists.
 * Accepts a generic payload shape so it can be used from both the Redux bridge
 * and the Zustand store without depending on Redux types.
 */
export const getBillingPlanErrorUsage = (
  payload: unknown,
):
  | {
      maximum: number;
      current: number;
    }
  | undefined => {
  if (typeof payload !== "object" || payload === null) {
    return undefined;
  }

  const p = payload as Record<string, unknown>;

  const usage =
    extractUsage(p.response) ?? extractUsage(p.data) ?? extractNestedUsage(p);

  if (
    usage != null &&
    typeof usage === "object" &&
    "current" in usage &&
    typeof (usage as Record<string, unknown>).current === "number"
  ) {
    const u = usage as { current: number; maximum?: number };
    return {
      maximum: u.maximum ?? Number.POSITIVE_INFINITY,
      current: u.current,
    };
  }

  return undefined;
};

function extractUsage(value: unknown): unknown {
  if (typeof value !== "object" || value === null) {
    return undefined;
  }
  return (value as Record<string, unknown>).usage;
}

function extractNestedUsage(value: Record<string, unknown>): unknown {
  const details = value.details;
  if (typeof details !== "object" || details === null) {
    return undefined;
  }
  const errorDetails = (details as Record<string, unknown>).errorDetails;
  if (typeof errorDetails !== "object" || errorDetails === null) {
    return undefined;
  }
  return (errorDetails as Record<string, unknown>).usage;
}
